import { combineReducers } from "redux";
import submittingChanges from "./submittingChanges";
import templates from "./templates";
import authenticatingUser from "./authenticatingUser";
import user from "./user";
import loadingTemplates from "./loadingTemplates";
import loadingSubjects from "./loadingSubjects";
import subjects from "./subjects";
import loadingAlignmentResults from "./loadingAlignmentResults";
import alignmentResults from "./alignmentResults";
import snackBarState from "./snackBarState";
import updateIds from "./updateIds";
import config from "./config";
import loadingConfig from "./loadingConfig";

export default () =>
  combineReducers({
    submittingChanges,
    loadingTemplates,
    loadingSubjects,
    loadingAlignmentResults,
    templates,
    subjects,
    alignmentResults,
    authenticatingUser,
    user,
    snackBarState,
    updateIds,
    config,
    loadingConfig,
  });
